module.exports = __webpack_public_path__ + "img/downloadpic.37dcffff.png";